import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Profile } from '@app/models';
import { APIURL } from 'app/shared/constants';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private BASE_PROFILE_URL = `${APIURL}profile/`;
  private _profile: Profile;

  get userTypeCode(): string | null {
    if (!this._profile) return null;
    return this._profile.userData.userTypeCode;
  }

  constructor(private http: HttpClient) {}

  async read(): Promise<Profile> {
    if (this._profile) return this._profile;

    const url: string = `${this.BASE_PROFILE_URL}read`;
    const response = await lastValueFrom(this.http.get<Profile>(url));
    this._profile = response;
    return response;
  }
}
